import { Component, OnInit } from '@angular/core';
import { TotalProductionService } from './total-production.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-total-production',
    imports: [],
    templateUrl: './total-production.html',
    styleUrl: './total-production.scss'
})
export class TotalProduction {

    constructor(
        public themeService: CustomizerSettingsService,
        private totalProductionService: TotalProductionService
    ) { }

    ngAfterViewInit(): void {
        this.totalProductionService.loadChart();
    }

    ngOnDestroy(): void {
        this.totalProductionService.destroyChart();
    }

}